import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import NavigationBar from './components/NavigationBar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AuthPage from './pages/AuthPage';
import AboutPage from './pages/AboutPage';
import AuctionPage from './pages/AuctionPage';
import ContactPage from './pages/ContactPage';
import './style/NavigationBar.css'
import './style/Banner.css'
import './style/IntroSection.css'
import './style/Footer.css'
import SellingPage from './pages/SellingPage';
import FaqPage from './pages/FaqPage';
import TermsPage from './pages/TermsPage';
import BidIncrementsPage from './pages/BidIncrementsPage';
import TopBar from './components/TopBar';
import PopupModal from './components/PopupModal';
import UpcomingAuctions from './pages/UpcomingAuctions';
import FeaturedLots from './pages/FeaturedLots';
import PastAuction from './pages/PastAuction';
import PastHighlights from './pages/PastHighlights';


function App() {
  return (
   <div>
      <PopupModal />
      <TopBar />
      <NavigationBar />
      <main>
        <Routes>
          {/* untuk strat langsung ke homepage */}
          <Route path="/" element={<Navigate replace to="/homepage" />} /> 

          <Route path="/homepage" element={<HomePage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/auction" element={<AuctionPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/selling" element={<SellingPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/bidincrement" element={<BidIncrementsPage />} />
          <Route path="/upcoming" element={<UpcomingAuctions />} />
          <Route path="/featured" element={<FeaturedLots />} />
          <Route path="/pasthighlights" element={<PastHighlights />} />
          <Route path="/pastauction" element={<PastAuction />} />
        </Routes>
      </main>

      <Footer />
   </div>
  );
}

export default App;
